// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1JtJp","label":"Section_label__1HmtH","contentWrap":"Section_contentWrap__1DIYm","footer":"Section_footer__pt-rq","footerInner":"Section_footerInner__16C0s"};